export class AppStateBackground {
    public static readonly type = '[Root state] App state background';
}
